import { injectExif } from "./exif";

const loadImage = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("unreadable")); };
    img.src = url;
  });

const toJpegDataUrl = (canvas) =>
  new Promise((resolve, reject) =>
    canvas.toBlob((b) => {
      if (!b) return reject(new Error("encode failed"));
      const r = new FileReader();
      r.onload = () => resolve(r.result);
      r.onerror = () => reject(r.error);
      r.readAsDataURL(b);
    }, "image/jpeg", 0.92));

const previewBase64 = (img, edge = 768) => {
  const scale = Math.min(1, edge / Math.max(img.naturalWidth, img.naturalHeight));
  const c = document.createElement("canvas");
  c.width = Math.round(img.naturalWidth * scale);
  c.height = Math.round(img.naturalHeight * scale);
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, c.width, c.height);
  ctx.drawImage(img, 0, 0, c.width, c.height);
  const b64 = c.toDataURL("image/jpeg", 0.8).split(",")[1];
  c.width = 0;
  return b64;
};

// One batch action: decode → (optional AI copy) → JPEG → EXIF → Blob ready for the ZIP.
// `describe(b64)` returns {title, tags, alt_text}; an AI failure keeps the file and reports aiFailed.
export async function processImage(file, meta, describe) {
  const img = await loadImage(file);
  let ai = null;
  let aiFailed = false;
  if (describe) {
    try { ai = await describe(previewBase64(img)); } catch { aiFailed = true; }
  }
  const canvas = document.createElement("canvas");
  canvas.width = img.naturalWidth;
  canvas.height = img.naturalHeight;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(img, 0, 0);
  const dataUrl = injectExif(await toJpegDataUrl(canvas), { ...meta, ai });
  canvas.width = 0;
  return { blob: await (await fetch(dataUrl)).blob(), ai, aiFailed };
}
